import React from "react"

function Briefcase({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.34 14.0015C28.34 13.206 27.6945 12.5605 26.9015 12.5605H9.09843C8.30549 12.5605 7.65997 13.206 7.65997 14.0015V18.1258C7.65997 18.9213 8.30549 19.5668 9.09843 19.5668H15.9406L16.125 17.3076H19.961L20.1393 19.5668H26.9015C27.6945 19.5668 28.34 18.9213 28.34 18.1258V14.0015Z"
        stroke="#003E4C"
        strokeWidth="1.00545"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.34 26.3973C28.34 27.1928 27.6945 27.8383 26.9015 27.8383H9.09843C8.30549 27.8383 7.65997 27.1928 7.65997 26.3973V22.273C7.65997 21.4775 8.30549 20.832 9.09843 20.832H15.9406L16.125 23.0912H19.961L20.1393 20.832H26.9015C27.6945 20.832 28.34 21.4775 28.34 22.273V26.3973Z"
        stroke="#003E4C"
        strokeWidth="1.00545"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8881 11.0331V9.49317C14.8881 9.3444 14.9434 9.20115 15.0541 9.09543C15.2569 8.88825 15.6134 8.53416 15.8225 8.32638C15.927 8.22126 16.0683 8.16162 16.2159 8.16162H19.8306C19.9782 8.16162 20.1195 8.22126 20.224 8.32638C20.427 8.52309 20.7527 8.84954 20.9433 9.04626C21.054 9.15137 21.1093 9.29461 21.1093 9.44399C21.1093 9.94194 21.1093 11.0663 21.1093 11.0663"
        stroke="#003E4C"
        strokeWidth="1.00545"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Briefcase
